import { createFileRoute, redirect } from "@tanstack/react-router";
import { Outlet } from "@tanstack/react-router";
import { getCurrentUserSafe } from "@/domain/auth/auth.query";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: async () => {
    const user = await getCurrentUserSafe();
    if (!user) {
      throw redirect({ to: "/connexion" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
